module.exports = __webpack_public_path__ + "img/thomas-le-b@small.a43d0531.png";